import React, { useEffect, useRef } from "react";
import App from "../App.jsx";
import ConsentBanner from "./ConsentBanner";
import Toasts from "./Toasts";
import Spinner from "./Spinner";
import { useAuthState } from "../hooks/useAuth";
import { useToasts } from "../hooks/useToasts";

const AppLayout = () => {
  const state = useAuthState();
  const { addToast } = useToasts();
  const lastShown = useRef(0);

  useEffect(() => {
    const handleUnavailable = () => {
      const now = Date.now();
      if (now - lastShown.current < 15000) return;
      lastShown.current = now;
      addToast("We're having trouble connecting.", "error-warning");
      addToast("Please try again shortly.", "error-warning");
    };
    window.addEventListener("api-unavailable", handleUnavailable);
    return () => window.removeEventListener("api-unavailable", handleUnavailable);
  }, [addToast]);

  return (
    <>
      <App />
      <ConsentBanner />
      <Spinner visible={state?.loading} />
      <Toasts />
    </>
  );
};

export default AppLayout;
